import {Component} from '@angular/core';
import {Block}     from "../../block";

@Component({
    selector   : 'app-navigational',
    templateUrl: './navigational.component.html',
})
export class NavigationalComponent extends Block {

}
